// pages/Conference.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';
function ConferenceAMZ() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div className="conference-page" >

    <div style={{
      padding: '80px 0 40px',
      textAlign: 'center',
      backgroundImage: 'url(/images/cover.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: '100%',
      marginLeft: 'calc(-50vw + 50%)',
      minHeight: '400px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1
      }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

      <style jsx>{`
        @media (max-width: 768px) {
          .conference-page > div:first-child {
            padding: 60px 0 30px !important;
            min-height: 300px !important;
          }
          .conference-page h1 {
            font-size: 2.5rem !important;
          }
          .conference-page h3 {
            font-size: 1.4rem !important;
          }
        }
      `}</style>
      <img
        src="/images/Asset5.png"
        alt="Conference Icon"
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain'
        }}
      />
      <h1 style={{
        fontSize: '3.5rem',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        direction: 'ltr'
      }}>
        ⵜⵉⵏⴰⵡⵜ
      </h1>

      <h3 style={{
        fontSize: '2rem',
        marginBottom: '20px',
        fontWeight: '600',
        lineHeight: '1.6',
        direction: 'ltr'
      }}>
        ⵜⵉⴽⵕⴹⵉ ⵏⵏⴰ ⵜⵙⵙⵀⵡⴰⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ
        <br />
        <span style={{ color: 'var(--primary-orange)', fontSize: '1.8rem' }}>
          ⴰⴱⵔⴱⴰⵢⵢⵓⵕ ⴰⵎⵓⵟⵟⵓⵏ ⵉⴼⵙⵙⵜⴰⵏ
        </span>
      </h3>
      <div style={{
        background: 'var(--secondary-black)',
        padding: '20px 30px',
        borderRadius: '15px',
        borderRight: '4px solid var(--primary-orange)',
        marginBottom: '25px',
        direction: 'ltr'
      }}>
        <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
        <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>ⴰⵙⴰⴽⵓⴷ:</strong> ⴰⴽⵕⴰⵙ 26 ⵏⵓⵡⴰⵏⴱⵉⵔ 2025
        </p>
        <p style={{ fontSize: '1.3rem' }}>
          <img src="/images/time.png" className="tab-icon3-img" /> <strong>ⴰⴽⵓⴷ:</strong> ⵙⴳ ⵜⵙⵔⴰⴳⵜ ⵜⵉⵙⵙ ⵙⵎⵎⵓⵙⵜ ⴷ ⵓⵣⴳⵏ ⵏ ⵜⴷⴳⴳⵯⴰⵜ
        </p>
      </div>
      </div>
    </div>

      {/* Conference Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0', direction: 'ltr' }}>
        <div className="container">



          {/* Statistics Section */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              ⵉⵙⵏⵎⴽⵜⴰ ⵙⵖⵉⵍⵓⴼⵏⵉⵏ
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  60%
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  ⵏ ⵜⵡⵜⵎⵉⵏ ⴳ ⵜⵎⵏⴰⴹⵜ ⵜⴰⵄⵕⴰⴱⵜ ⴰⵔ ⵜⵜⵎⵏⴰⵍⴰⵏⵜ ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  1.5M
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  ⵏ ⵜⵎⵖⴰⵔⵜ ⵜⴰⵎⵖⵔⵉⴱⵉⵜ ⴰⵔ ⵜⵜⵎⵏⴰⵍⴰⵏⵜ ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴽⵓ ⴰⵙⴳⴳⵯⴰⵙ
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  44%
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  ⵙⴳ ⵡⴰⴷⴷⴰⴷⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴰⵔ ⵜⵜⵎⵓⵜⵜⵓⵢⵏ ⵖⵔ ⵜⵉⵍⴰⵡⵜ
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'left',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  11%
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  ⵙⴳ ⵜⵓⵏⴳⵉⵙⵉⵏ ⴽⴰ ⴰⴷ ⵉⵙⵙⵉⵡⵉⴹⵏ ⵅⴼ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ
                </p>
              </div>
            </div>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '35px',
              borderRadius: '15px',
              borderRight: '5px solid var(--primary-orange)',
              textAlign:'left'
            }}>
              <h4 style={{ fontSize: '1.6rem', marginBottom: '20px', color: 'var(--white)' }}>
                ⵜⵉⵡⵉⵍⴰⵜⵉⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵉⵜⵜⵡⴰⵙⵙⴰⵏⵏ ⴰⵟⵟⴰⵚ
              </h4>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '15px'
              }}>
                <div>• ⴰⵙⵉⵙⵙⵏ ⴷ ⵓⵎⵍⴰⵏ ⵏ ⵜⴽⵔⴽⴰⵙ (67%)</div>
                <div>• ⴰⵥⵍⵍⴻⵍ ⴰⵍⵉⴽⵟⵕⵓⵏⵉ (66%)</div>
                <div>• ⴰⵡⵏⵏⵉ ⵏ ⵓⴽⵙⴰⵏ (65%)</div>
                <div>• ⴰⵣⵓⵅⵅⵓ ⴷ ⵜⴰⴷⴱⵔⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ</div>
                <div>• ⴰⵙⵃⵍⵍⴻⵍ ⵉⵖⴱⴰⵏ ⴷ ⵜⵖⵉⵙⵜ ⵜⵉⵎⵍⵥⵉⵜ</div>
                <div>• ⵜⴰⵙⴱⴱⴰⴱⵜ ⵜⴰⵍⵉⴽⵟⵕⵓⵏⵉⵜ ⴳ ⵉⵡⴷⴰⵏ</div>
              </div>
            </div>
          </div>

          {/* Conference Objectives */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'left',
              color: 'var(--white)',

            }}>
              ⵉⵡⵜⵜⴰⵙⵏ ⵏ ⵜⵉⵏⴰⵡⵜ
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              direction: 'ltr',
              textAlign:'left'
            }}>
              {[
                {
                  icon: '🛡️',
                  title: 'ⴰⴼⵔⴰⴳ ⴷ ⵓⵙⵎⵓⵙⵙⵓ',
                  desc: 'ⴰⵙⴷⵓⵙ ⵏ ⵓⴼⵔⴰⴳ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵜⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ ⴳ ⵓⵙⴰⵢⵔⴰⵔ ⴰⵎⵓⵟⵟⵓⵏ ⴷ ⵜⵉⵣⵉ ⵏ ⵜⵖⵉⵙⵜ ⵜⵉⵎⵍⵥⵉⵜ'
                },
                {
                  icon: '📚',
                  title: 'ⴰⵙⴼⵔⴽ ⴷ ⵓⵙⵏⵎⵍ',
                  desc: 'ⴰⵙⵏⵎⵍ ⵙ ⵉⵙⵎⵔⵙⵏ ⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵉⵙⴱⴷⴷⵉⵏ ⵉⵣⵔⴼⴰⵏ ⴷ ⵓⵙⴷⵓⵙ ⵏ ⵉⵣⵎⴰⵣ ⵏ ⵡⴰⵔⴰⵢ ⵙⴳⵉⵙ'
                },
                {
                  icon: '🔔',
                  title: 'ⴰⵙⴼⵔⴽ ⴷ ⵓⵙⵉⵡⴹ',
                  desc: 'ⵜⴰⵏⴽⵔⴰ ⵙ ⵜⵓⵙⵙⵏⴰ ⵏ ⵜⵏⴼⵔⵓⵜ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⴷ ⵓⵙⵙⵔⵇⴱ ⵅⴼ ⵓⵙⵉⵡⴹ ⵅⴼ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ'
                },
                {
                  icon: '⚖️',
                  title: 'ⴰⵙⵇⵙⵉ',
                  desc: 'ⴰⵙⵙⵉⴷⴷ ⵅⴼ ⵜⵎⵙⵜⴳⴳⴰⵔⵉⵏ ⵏ ⵜⴷⴰⴱⵓⵜⵉⵏ ⵜⵉⵅⴰⵜⴰⵔⵉⵏ ⴳ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ'
                },
                {
                  icon: '🔊',
                  title: 'ⵜⵉⵕⵥⵉ ⵏ ⵉⴼⵙⵙⵜⵉ',
                  desc: 'ⴰⵙⵙⵔⵇⴱ ⵅⴼ ⵉⴱⵔⴷⴰⵏ ⵉⵎⵢⴰⵏⴰⵡⵏ ⵏ ⵓⵙⵉⵡⴹ ⴷ ⵜⵕⵥⵉ ⵏ ⵉⴼⵙⵙⵜⵉ ⵏ ⵜⵓⵏⴳⵉⵙⵉⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '25px',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  transition: 'all 0.3s ease',
                  direction: 'ltr'
                }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{item.icon}</div>
                  <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Conference Program */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              ⴰⵖⴰⵡⴰⵙ ⵏ ⵜⵉⵏⴰⵡⵜ
            </h3>

            <div style={{
              background: 'var(--primary-black)',
              padding: '35px',
              borderRadius: '15px',
              border: '2px solid var(--primary-orange)',
              textAlign:'left'
            }}>
              {[
                { time: '17:00-17:30', event: 'ⴰⵙⵓⵏⴼⵓ ⵏ ⵡⴰⵜⴰⵢ', type: 'welcome' },
                { time: '17:30-17:45', event: 'ⵜⴰⴳⵓⵔⵉ ⵏ ⵎⴰⵙⵙⴰ ⴰⵎⵉⵏⴰ ⴱⵓⵄⵢⵢⴰⵛ, ⵜⴰⵏⵙⵙⵉⵅⴼⵜ ⵏ ⵓⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ', type: 'opening' },
                { time: '17:45-18:00', event: 'ⵜⴰⴳⵓⵔⵉ ⵏ ⵎⴰⵙⵙⴰ ⵏⴰⵄⵉⵎⴰ ⴱⵏ ⵢⴰⵃⵢⴰ, ⵜⴰⵎⴰⵡⵙⴰⵙⵜ ⵏ ⵜⴱⴷⴰⴷⵜ ⴷ ⵓⵙⵉⴷⴼ ⴰⵏⴰⵎⵓⵏ ⴷ ⵜⵡⵊⴰ', type: 'opening' },
                { time: '18:15-18:30', event: 'ⵜⴰⴳⵓⵔⵉ ⵏ ⵎⴰⵙⵙ ⵛⴰⴽⵉⴱ ⴱⵏⵎⵓⵙⴰ, ⴰⵎⴰⵍⴰⵍ ⴰⵎⴰⵜⴰⵢ ⵏ ⵓⵙⵖⵉⵡⵙ', type: 'opening' },
                { time: '18:30-18:45', event: 'ⵜⴰⴳⵓⵔⵉ ⵏ ⵎⴰⵙⵙⴰ ⵎⴰⵔⵢⴰⵎ ⵓⵛⵛⵏ ⵏⵏⴰⵚⵉⵕⵉ, ⵜⴰⴳⵏⵙⴰⵙⵜ ⵏ ⵓⴳⵔⴰⵡ ⵏ ⵜⵎⵜⵜⴰ ⵉⵎⵓⵏⵏ ⵏ ⵜⵎⵖⴰⵔⵜ ⴳ ⵍⵎⵖⵔⵉⴱ', type: 'opening' },
                { time: '18:45-19:00', event: 'ⵜⴰⴳⵓⵔⵉ ⵏ ⵎⴰⵙⵙⴰ ⵏⴰⵀⵍⴰ ⵃⴰⵢⴷⴰⵔ, ⵜⴰⵏⵙⵙⵉⵅⴼⵜ ⵏ ⵜⵙⵇⵇⵉⵎⵜ ⵏ ⵜⵎⵜⵜⴰ ⵉⵎⵓⵏⵏ ⵉ ⵓⵙⴱⴷⴷⵉ ⵏ ⵓⵙⵏⵓⵃⵢⵓ ⵎⴳⴰⵍ ⵜⴰⵎⵖⴰⵔⵜ (CEDAW)', type: 'keynote' },
                { time: '19:00-19:30', event: 'ⴰⵎⵢⴰⵖ ⵏ ⵜⵉⵎⴷⵔⴰⵡⵉⵏ/ⵉⵎⴷⵔⴰⵡⵏ', type: 'panel' },
                { time: '19:30-20:00', event: 'ⴰⵙⴼⵓⴳⵍⵓ ⵏ ⵓⵙⵙⵏⵜⵉ ⵏ ⵓⵎⵣⵉⵣⵣⵍ ⵏ ⵓⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ (16 ⵏ ⵡⵓⵙⵙⴰⵏ / 12 ⵏ ⵜⵎⵏⴰⴹⵜ)', type: 'ceremony' }
              ].map((item, index) => (
                <div key={index} style={{
                  padding: '20px',
                  borderBottom: index < 7 ? '1px solid rgba(255, 107, 53, 0.2)' : 'none',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '20px'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
                    padding: '10px 20px',
                    borderRadius: '10px',
                    fontWeight: '700',
                    fontSize: '1.1rem',
                    minWidth: '140px',
                    textAlign: 'center'
                  }}>
                    {item.time}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                      {item.event}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div style={{
              marginTop: '30px',
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '25px',
              borderRadius: '15px',
              textAlign: 'center',
              direction: 'ltr'
            }}>
              <h4 style={{ fontSize: '1.4rem', marginBottom: '15px', color: 'var(--primary-orange)' }}>
                ⵜⵉⵎⴷⵔⴰⵡⵉⵏ / ⵉⵎⴷⵔⴰⵡⵏ
              </h4>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-light)' }}>
                ⴰⴱⵕⵍⴰⵎⴰⵏ • ⵜⴰⵎⴰⵡⴰⵙⵜ ⵏ ⵜⵣⵔⴼⵜ • ⵜⴰⵎⴰⵡⴰⵙⵜ ⵏ ⵓⵙⵙⵍⵎⴷ ⴰⵎⴰⵜⵜⴰⵢ ⴷ ⵓⵔⵣⵣⵓ ⴰⵎⴰⵙⵙⴰⵏ ⴷ ⵓⵙⵏⴼⵍⵓⵍ • ⴰⵙⵇⵇⵉⵎ ⴰⴷⵎⵙⴰⵏ ⴷ ⵓⵏⴰⵎⵓⵏ ⴷ ⵓⵡⵏⴹⴰⵏ
                <br />
                ⴰⴳⵔⴰⵡ ⴰⵎⴰⵜⴰⵢ ⵏ ⵓⵎⵢⴰⵡⴰⴹ ⴰⵙⵍⵉⵥⵕ • ⵜⴰⵎⵀⵍⴰ ⵜⴰⵎⴰⵜⴰⵢⵜ ⵏ ⵜⵏⴼⵔⵓⵜ ⵜⴰⵏⴰⵎⵓⵔⵜ
                <br />
                ⵜⴰⵙⵇⵇⵉⵎⵜ ⵜⴰⵏⴰⵎⵓⵔⵜ ⵏ ⵓⴼⵔⴰⴳ ⵏ ⵉⵙⴼⴽⴰ ⵉⵏⵉⵎⴰⵏⵏ • ⵜⴰⵎⵙⵇⴰⴷⵜ ⵏ ⵜⴰⵎⵓⵏⵜ ⵏ ⵓⵕⵓⴱⴱⴰ
                <br />
                ⵜⵉⵎⵙⵎⵓⵏⵉⵏ ⵏ ⵡⴰⵎⵓⵏ ⵓⵖⵔⵉⵎ • ⵓⴷⵎⴰⵡⵏ ⵉⵏⵖⵎⴰⵙⵏ
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mapping Show Section */}
      <div style={{ background: 'var(--primary-black)', padding: '60px 0', direction: 'ltr' }}>
        <div className="container">
          <div className="section-separator" style={{ margin: '0 0 60px 0' }}></div>

          <div className="container" style={{ padding: '80px 20px 40px', textAlign: 'center', direction: 'ltr' }}>
            <img
              src="/images/Asset6.png"
              alt="Conference Icon"
              style={{
                width: '80px',
                height: '80px',
                objectFit: 'contain'
              }}
            />
            <h1 style={{
              fontSize: '3.5rem',
              marginBottom: '20px',
              background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              direction: 'ltr'
            }}>
            ⴰⴼⵙⴰⵔ ⵏ ⵜⵉⴼⴰⵡⵜ (Mapping show)
            </h1>
            <p style={{
              fontSize: '1.3rem',
              lineHeight: '1.9',
              marginBottom: '25px',
              color: 'var(--text-light)',
              direction: 'ltr'
            }}>
              ⵜⵉⵔⵎⵉⵜ ⵉⵎⵉⵥⵕ ⴰⵥⵓⵕⴰⵏ ⴰⵎⵙⵏⴼⵍⵓⵍ ⵙ ⵓⵙⵎⵔⵙ ⵏ ⵜⴰⵜⵉⵇⵏⵉⵜ ⵏ ⵍⴼⵉⴷⵢⵓ "ⵎⴰⴱⴱⵉⵏⴳ" ⵙ ⵓⵙⵏⴼⵍ ⵏ ⵡⵓⴷⵎ ⵏ ⵓⵙⵖⵉⵎ ⵏ ⵓⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⵙ ⵜⴼⵉⵍⵜ ⵜⴰⵥⵓⵕⴰⵏⵜ ⵜⴰⵎⵉⴷⵉⵔⵜ ⵉⵜⵜⴰⵍⵙⵏ ⵜⴰⵍⵍⴰⵙⵉⵏ ⵏ ⵜⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ ⵜⵓⵏⴳⵉⵙⵉⵏ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ.
            </p>
            <div style={{
              background: 'var(--secondary-black)',
              padding: '20px 30px',
              borderRadius: '15px',
              borderRight: '4px solid var(--primary-orange)',
              marginBottom: '25px',
              direction: 'ltr'
            }}>
              <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
                  <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong> ⴰⵙⴰⴽⵓⴷ ⴰⵎⴰⴷⴷⵓⴷ ⵏ ⵓⵙⵏⵜⵉ:</strong> ⴰⴽⵕⴰⵙ 26 ⵏⵓⵡⴰⵏⴱⵉⵔ 2025
              </p>
              <p style={{ fontSize: '1.3rem' }}>
                <img src="/images/time.png" className="tab-icon3-img" /> <strong>ⴰⴽⵓⴷ: </strong>ⴽⵓ ⴰⵙⵙ ⵙⴳ ⵜⵙⵔⴰⴳⵜ ⵜⵉⵙ 19:30
              </p>
            </div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px',
            alignItems: 'center'
          }}>



          </div>




          <div className="section-separator"></div>

                <div style={{ textAlign: 'center', marginTop: '50px', direction: 'ltr' }}>
                  <h3 style={{
                    fontSize: '2.5rem',
                    marginBottom: '25px',
                    color: 'var(--white)',
                    direction: 'ltr'
                  }}>
              ⴳ ⴰⵎⵙⴽⴰⵔ ⴳ ⵓⵙⵏⴼⵍ
                  </h3>

                  <p style={{
                    fontSize: '1.2rem',
                    marginTop: '30px',
                    color: 'var(--text-light)',
                    fontStyle: 'italic',
                    direction: 'ltr'
                  }}>
                ⴽⵓⵍⵍⵓ ⴰⵖ ⴰⴷ ⵏⵕⵕⵥ ⴰⴳⴰⴷⵉⵔ ⵏ ⵉⴼⵙⵙⵜⵉ | ⴽⵓⵍⵍⵓ ⴰⵖ ⴰⴷ ⵏⴱⴷⴷ ⵎⴳⴰⵍ ⵓⴱⵔⴱⴰⵢⵢⵓⵕ ⴰⵎⵓⵟⵟⵓⵏ ⵉⴼⵙⵙⵜⴰⵏ
                  </p>
                </div>
        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default ConferenceAMZ;
